import { StyledElement } from 'app/slate/components/StyledElement';
import { BlockTaggableList } from 'app/slate/components/BlockTaggableList';
import { useMemo } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { BookmarkElement } from '../extensions/bookmark';
import { LinkElement } from '../extensions/link';
import { StyledParagraphElement } from '../extensions/styled-paragraph';
import { HighlightElement } from '../extensions/highlight';
import { TagElement } from '../extensions/tag';
import { ExcludeElement } from 'app/slate/extensions/tag/components/ExcludeElement';
import { FootnoteElement } from 'app/slate/extensions/tag/components/FootnoteElement';
import { ListItemElement } from './ListItemElement';

export const Element = (props) => {
  const { attributes, children, element } = props;
  const elementUUID = useMemo(() => element.uuid || uuidv4(), [element.uuid]);
  const listId = `xrp-list-${elementUUID}`;

  // Add id to attributes if it does not exist
  const safeAttributesWithId = (attrs) => ({
    ...attrs,
    id: attrs.id || listId,
  });
  switch (element.type) {
    case 'table':
      return (
        <table>
          <tbody style={{ userSelect: 'none' }} contentEditable={false} {...attributes}>
            {children}
          </tbody>
        </table>
      );
    case 'bulleted-list':
      return (
        <BlockTaggableList as="ul" attributes={safeAttributesWithId(attributes)} element={element} elementUUID={elementUUID}>
          {children}
        </BlockTaggableList>
      );
    case 'numbered-list':
      return (
        <BlockTaggableList as="ol" attributes={safeAttributesWithId(attributes)} element={element} elementUUID={elementUUID}>
          {children}
        </BlockTaggableList>
      );
    case 'list-item':
      return <ListItemElement {...props} />;
    case 'table-row':
      return <tr {...attributes}>{children}</tr>;
    case 'table-cell':
      return <td {...attributes}>{children}</td>;
    case 'paragraph':
      return <StyledElement {...props} />;
    case 'custom-formatting':
      return <StyledElement {...props} />;
    case 'bookmark':
      return <BookmarkElement {...props} />;
    case 'styled-paragraph':
      return <StyledParagraphElement {...props} />;
    case 'link':
      return <LinkElement {...props} />;
    case 'highlight':
      return <HighlightElement {...props} />;
    case 'tag':
      return <TagElement {...props} />;
    case 'exclude':
      return <ExcludeElement {...props} />;
    case 'footnote':
      return <FootnoteElement {...props} />;
    default:
      console.warn('No explicit type for render in editor found, using default element', props);
      return (
        <p className="default-editor-element" {...attributes}>
          {children}
        </p>
      );
  }
};
